icons = [
    {
        id: "icon-00001",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00001.png",
        name: "Zielscheibe (grün)"
    },
    {
        id: "icon-00002",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00002.png",
        name: "Zielscheibe (gelb)"
    },
    {
        id: "icon-00003",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00003.png",
        name: "Zielscheibe (schwarz)"
    },
    {
        id: "icon-00004",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00004.png",
        name: "Zielscheibe (grau)"
    },
    
    {
        id: "icon-00005",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00005.png",
        name: "Zielscheibe (rot)"
    },
    {
        id: "icon-00006",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00006.png",
        name: "Ring (grün)"
    },
    {
        id: "icon-00007",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00007.png",
        name: "Ring (rot)"
    },
    {
        id: "icon-00008",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00008.png"
    },
    {
        id: "icon-00009",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00009.png"
    },
    {
        id: "icon-00010",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00010.png"
    },
    {
        id: "icon-00011",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00011.png"
    },
    {
        id: "icon-00012",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00012.png"
    },
    
    {
        id: "icon-00013",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00013.png"
    },
    {
        id: "icon-00014",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00014.png"
    },
    {
        id: "icon-00015",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00015.png"
    },
    {
        id: "icon-00016",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00016.png"
    },
    {
        id: "icon-00017",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00017.png"
    },
    {
        id: "icon-00018",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00018.png"
    },
    {
        id: "icon-00019",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00019.png"
    },
    {
        id: "icon-00020",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00020.png"
    },
    {
        id: "icon-00021",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00021.png"
    },
    {
        id: "icon-00022",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00022.png"
    },
    {
        id: "icon-00023",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00023.png"
    },
    {
        id: "icon-00024",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00024.png"
    },
    {
        id: "icon-00025",
        file: "th-test-visuelle-merkfaehigkeit-bu-images-icon-00025.png",
        name: "abhebendes Flugzeug (rot)"
    } 
    
];



// remove all icons from icons except for 3 random items
function keep4Icons() {
    let newIcons = [];
    for (let i = 0; i < 4; i++) {
        let randomIndex = Math.floor(Math.random() * icons.length);
        newIcons.push(icons[randomIndex]);
        icons.splice(randomIndex, 1);
    }
    return newIcons;
}

icons = keep4Icons()